module.exports = __webpack_public_path__ + "img/juriafrique.50ddd78b.png";